import { render, staticRenderFns } from "./TnyWeaponModal.vue?vue&type=template&id=37a2ccb4&"
import script from "./TnyWeaponModal.vue?vue&type=script&lang=ts&"
export * from "./TnyWeaponModal.vue?vue&type=script&lang=ts&"
import style0 from "./TnyWeaponModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports